import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Suppress ResizeObserver loop limit errors during development to prevent annoying crash overlays in CRA
const preventResizeObserverError = (e) => {
  if (e.message && (e.message.includes('ResizeObserver') || e.message.includes('Resize observer'))) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
};
window.addEventListener('error', preventResizeObserverError, true);
window.addEventListener('unhandledrejection', (e) => {
  if (e.reason && e.reason.message && (e.reason.message.includes('ResizeObserver') || e.reason.message.includes('Resize observer'))) {
    e.preventDefault();
  }
}, true);

// Patch ResizeObserver constructor to run callback inside requestAnimationFrame, deferring layout logic
const OriginalResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends OriginalResizeObserver {
  constructor(callback) {
    super((entries, observer) => {
      window.requestAnimationFrame(() => {
        try {
          callback(entries, observer);
        } catch (err) {
          // Suppress errors if elements are unmounted during deferred execution
        }
      });
    });
  }
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
